import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AudioPlayer {
  private audio: HTMLAudioElement;
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  initialize(src: string): HTMLAudioElement | undefined {
    if (isPlatformBrowser(this.platformId)) {
      this.audio = new Audio(src);
      this.audio?.load();
      this.onCanPlay();
      return this.audio;
    }
  }

  onCanPlay(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.audio) {
        this.audio.oncanplay = () => {
          resolve();
        };
      }
    });
  }

  play(): void {
    if (this.audio) {
      this.audio?.play();
    } else {
      throw new Error('audio was not initialized. Please call initialize()');
    }
  }

  pause(): void {
    this.audio?.pause();
  }

  onFinish(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.audio) {
        this.audio.onended = () => {
          resolve();
        };
      }
    });
  }
}
